import React from 'react';
import MobileFooterView from './MobileFooterView';
import { UseMobileFooterViewProps } from './type';
import { useMobileFooter } from './useMobileFooter';

function MobileFooter() {
  const hook: UseMobileFooterViewProps = useMobileFooter();

  return <MobileFooterView hook={hook} />;
}
export default React.memo(MobileFooter);
